import { render, staticRenderFns } from "./UpdatesForm.vue?vue&type=template&id=40cd01ef&"
import script from "./UpdatesForm.vue?vue&type=script&lang=js&"
export * from "./UpdatesForm.vue?vue&type=script&lang=js&"
import style0 from "./UpdatesForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports